import type { Button, ButtonVariant } from '$models/Button/Button';

/**
 * Interface that represents a Block model.
 *
 * @interface
 */
export interface Block {
	htmlId: string | null;
	htmlClass: string | null;
	type: string;
	title: string | null;
	subtitle: string | null;
	titleAlignment: string;
	outro: {
		text: string | null;
		button: Button | null;
		buttonClass: ButtonVariant;
	} | null;
	variant: string;
	variantBackgroundColor: string | null;
}

export function isBlock(unknown: any): unknown is Block {
	return unknown && typeof unknown.type === 'string';
}
